// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionPreviewController from "./accordion_preview_controller"
application.register("accordion-preview", AccordionPreviewController)

import AddTestsToStepController from "./add_tests_to_step_controller"
application.register("add-tests-to-step", AddTestsToStepController)

import AddressController from "./address_controller"
application.register("address", AddressController)

import AgeCheckController from "./age_check_controller"
application.register("age-check", AgeCheckController)

import ApiKeyManagerController from "./api_key_manager_controller"
application.register("api-key-manager", ApiKeyManagerController)

import ApplicationRequirementsController from "./application_requirements_controller"
application.register("application-requirements", ApplicationRequirementsController)

import CandidateCardController from "./candidate_card_controller"
application.register("candidate-card", CandidateCardController)

import CandidateLoginAccessController from "./candidate_login_access_controller"
application.register("candidate-login-access", CandidateLoginAccessController)

import CandidateJob__AddToJobController from "./candidate_job/add_to_job_controller"
application.register("candidate-job--add-to-job", CandidateJob__AddToJobController)

import CandidateJob__SendWhatsappController from "./candidate_job/send_whatsapp_controller"
application.register("candidate-job--send-whatsapp", CandidateJob__SendWhatsappController)

import CandidateJobBulkSelectorController from "./candidate_job_bulk_selector_controller"
application.register("candidate-job-bulk-selector", CandidateJobBulkSelectorController)

import CandidateJobFilterController from "./candidate_job_filter_controller"
application.register("candidate-job-filter", CandidateJobFilterController)

import CandidateJobSortableController from "./candidate_job_sortable_controller"
application.register("candidate-job-sortable", CandidateJobSortableController)

import CandidateJobSpinnerController from "./candidate_job_spinner_controller"
application.register("candidate-job-spinner", CandidateJobSpinnerController)

import CandidateJobsViewToggleController from "./candidate_jobs_view_toggle_controller"
application.register("candidate-jobs-view-toggle", CandidateJobsViewToggleController)

import CandidateVacanciesController from "./candidate_vacancies_controller"
application.register("candidate-vacancies", CandidateVacanciesController)

import CepLookupController from "./cep_lookup_controller"
application.register("cep-lookup", CepLookupController)

import ClipboardAutoCopyController from "./clipboard_auto_copy_controller"
application.register("clipboard-auto-copy", ClipboardAutoCopyController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorController from "./color_controller"
application.register("color", ColorController)

import CombinedMentionsController from "./combined_mentions_controller"
application.register("combined-mentions", CombinedMentionsController)

import CompanyEmployeeSearchController from "./company_employee_search_controller"
application.register("company-employee-search", CompanyEmployeeSearchController)

import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

import CreditCalculatorController from "./credit_calculator_controller"
application.register("credit-calculator", CreditCalculatorController)

import DocumentFormController from "./document_form_controller"
application.register("document-form", DocumentFormController)

import EmailCandidatesReceiversBulkController from "./email_candidates_receivers_bulk_controller"
application.register("email-candidates-receivers-bulk", EmailCandidatesReceiversBulkController)

import EmailVariableSelectorController from "./email_variable_selector_controller"
application.register("email-variable-selector", EmailVariableSelectorController)

import EsproHistoryController from "./espro_history_controller"
application.register("espro-history", EsproHistoryController)

import EsproProgramsController from "./espro_programs_controller"
application.register("espro-programs", EsproProgramsController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import ForumController from "./forum_controller"
application.register("forum", ForumController)

import GenderFieldsController from "./gender_fields_controller"
application.register("gender-fields", GenderFieldsController)

import GraduationFormController from "./graduation_form_controller"
application.register("graduation-form", GraduationFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InitializeCommonScriptController from "./initialize_common_script_controller"
application.register("initialize-common-script", InitializeCommonScriptController)

import InputMasksController from "./input_masks_controller"
application.register("input-masks", InputMasksController)

import JobColumnSortableController from "./job_column_sortable_controller"
application.register("job-column-sortable", JobColumnSortableController)

import JobDescriptionController from "./job_description_controller"
application.register("job-description", JobDescriptionController)

import JobPersonaController from "./job_persona_controller"
application.register("job-persona", JobPersonaController)

import JobPublicationController from "./job_publication_controller"
application.register("job-publication", JobPublicationController)

import KeyQuestionEditController from "./key_question_edit_controller"
application.register("key-question-edit", KeyQuestionEditController)

import KeyQuestionRemoveAllController from "./key_question_remove_all_controller"
application.register("key-question-remove-all", KeyQuestionRemoveAllController)

import KeyQuestionSortableController from "./key_question_sortable_controller"
application.register("key-question-sortable", KeyQuestionSortableController)

import LandingPageSectionActivationController from "./landing_page_section_activation_controller"
application.register("landing-page-section-activation", LandingPageSectionActivationController)

import LanguagesFieldsController from "./languages_fields_controller"
application.register("languages-fields", LanguagesFieldsController)

import LinkedinPluginTokenManagerController from "./linkedin_plugin_token_manager_controller"
application.register("linkedin-plugin-token-manager", LinkedinPluginTokenManagerController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import MatchmakingController from "./matchmaking_controller"
application.register("matchmaking", MatchmakingController)

import MaskBirthdateController from "./mask_birthdate_controller"
application.register("mask-birthdate", MaskBirthdateController)

import MaskCpfController from "./mask_cpf_controller"
application.register("mask-cpf", MaskCpfController)

import MaskMoneyController from "./mask_money_controller"
application.register("mask-money", MaskMoneyController)

import MaskPhoneController from "./mask_phone_controller"
application.register("mask-phone", MaskPhoneController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PasswordControlController from "./password_control_controller"
application.register("password-control", PasswordControlController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PcdFieldsController from "./pcd_fields_controller"
application.register("pcd-fields", PcdFieldsController)

import PipelineStepsController from "./pipeline_steps_controller"
application.register("pipeline-steps", PipelineStepsController)

import PlansController from "./plans_controller"
application.register("plans", PlansController)

import PositionFormController from "./position_form_controller"
application.register("position-form", PositionFormController)

import ProcessOwnerFilterController from "./process_owner_filter_controller"
application.register("process-owner-filter", ProcessOwnerFilterController)

import ProfileEditFormController from "./profile_edit_form_controller"
application.register("profile-edit-form", ProfileEditFormController)

import ProfileSourceFormController from "./profile_source_form_controller"
application.register("profile-source-form", ProfileSourceFormController)

import RefineWithAiController from "./refine_with_ai_controller"
application.register("refine-with-ai", RefineWithAiController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import SharedLinkFormController from "./shared_link_form_controller"
application.register("shared-link-form", SharedLinkFormController)

import StepDropdownController from "./step_dropdown_controller"
application.register("step-dropdown", StepDropdownController)

import StepSortableController from "./step_sortable_controller"
application.register("step-sortable", StepSortableController)

import TestsSearchController from "./tests_search_controller"
application.register("tests-search", TestsSearchController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import ToggleOptionsController from "./toggle_options_controller"
application.register("toggle-options", ToggleOptionsController)

import TransferRequestClipboardController from "./transfer_request_clipboard_controller"
application.register("transfer-request-clipboard", TransferRequestClipboardController)

import UnsavedDataController from "./unsaved_data_controller"
application.register("unsaved-data", UnsavedDataController)

import VulnerabilityFormController from "./vulnerability_form_controller"
application.register("vulnerability-form", VulnerabilityFormController)
